var lib_core      = require("lib-core");
var lib_geometry  = require("lib-geometry");


var Selection3dModel = require("./selection3dModel.js");
var Selection3dStateMachine = require("./selection3dStateMachine.js");

var Camera3d = require("./../camera3d/camera3dController.js");

var Editor3d = require("./../editor3d/editor3dController.js");

var Selection3dController = function(archLayers, dependencies, options) {
    lib_core.Controller.call(this, archLayers, dependencies, options);
};

lib_core.inherit(Selection3dController, lib_core.Controller);
Selection3dController.inject = {
    camera3d : Camera3d,
    editor3d : Editor3d
};
module.exports = Selection3dController;

Selection3dController.prototype.createModel = function () {
    var editor3dModel = this.editor3d.getModel();
    var camera3dModel = this.camera3d.getModel();

    return new Selection3dModel(editor3dModel, camera3dModel);
};


Selection3dController.prototype.createStateMachine = function () {
    var editor3dModel = this.editor3d.getModel();

    return new Selection3dStateMachine(this.getModel(), editor3dModel, this.rootStateMachine);
};


